<template>
  <div>
    <div class="text-center pt-4" v-if="loading">
      <b-spinner label="Cargando..."/>
      Cargando...
    </div>

    <b-alert
        variant="warning"
        v-if="errorMessage"
        show
    >
      <div class="alert-body font-small-2">
        <p>
          <small class="mr-50">
            <span class="font-weight-bold">{{ errorMessage }}</span>
          </small>
        </p>
      </div>
    </b-alert>

    <b-row>
      <b-col>
        <b-form @submit.prevent="save(item)">
          <!--SubTitle-->
          <b-row>
            <b-col>
              <b-form-group
                  label="Locación"
              />
            </b-col>
          </b-row>
          <!--End SubTitle-->
          <b-row>
            <b-col cols="6">
              <label>
                Fecha
              </label>
              <b-form-group>
                <b-form-datepicker
                    id="dateE-datepicker"
                    v-model="selectedSince"
                    class="mb-1"
                    placeholder="Fecha"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="es"
                    @input="formatDateSince(selectedSince + 'T23:59:59.999Z')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Semana Epidemiológico" label-for="weekE">
                <b-form-input id="weekE" type="text" v-model="item.week" disabled></b-form-input>
              </b-form-group>
            </b-col>  
            <b-col cols="6">
              <b-form-group
                  label="Región"
                  label-for="region"
              >
                <b-form-select
                    v-model="region"
                    :options="locations.regiones"
                    options-field="none"
                    id="region"
                    text-field="region"
                    @change="getDistritos()"
                >
                  <template #first>
                    <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                  label="Distrito"
                  label-for="district"
              >
                <b-form-select
                    v-model="district"
                    :options="locations.distritos"
                    options-field="none"
                    id="distrito"
                    text-field="distrito"
                    @change="getCorregimientos()"
                >
                  <template #first>
                    <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                  label="Corregimiento"
                  label-for="corregimiento"
              >
                <b-form-select
                    v-model="corregimiento"
                    :options="locations.corregimientos"
                    options-field="none"
                    id="corregimiento"
                    text-field="corregimiento"
                    @change="getLocalidades()"
                >
                  <template #first>
                    <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                  label="Localidad"
                  label-for="localidad"
              >
                <b-form-select
                    v-model="localidad"
                    :options="locations.localidades"
                    options-field="none"
                    id="localidad"
                    text-field="localidad"
                >
                  <template #first>
                    <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="3">
              <b-form-group
                  label="Manz. Trabajadas"
                  label-for="manzanas"
              >
                <b-form-input
                    id="name"
                    v-model="item.manzanas"
                    placeholder=""
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                  label="Predios Inspct."
                  label-for="predios"
              >
                <b-form-input
                    id="name"
                    v-model="item.predios"
                    placeholder=""
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                  label="Tratados"
                  label-for="tratados"
              >
                <b-form-input
                    id="name"
                    v-model="item.tratados"
                    placeholder=""
                    type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <!--SubTitle-->
          <b-row>
            <b-col>
              <b-form-group
                  label="Factores de Riesgo"
              />
            </b-col>
          </b-row>
          <!--End SubTitle-->
          <b-row>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="1"
                  label-for="riskOne"
              >
                <b-form-input
                    id="riskOne"
                    v-model="item.riskOne"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="2"
                  label-for="riskTwo"
              >
                <b-form-input
                    id="riskTwo"
                    v-model="item.riskTwo"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="3"
                  label-for="riskThree"
              >
                <b-form-input
                    id="riskThree"
                    v-model="item.riskThree"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="4"
                  label-for="riskFour"
              >
                <b-form-input
                    id="riskFour"
                    v-model="item.riskFour"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="5"
                  label-for="riskFive"
              >
                <b-form-input
                    id="riskFive"
                    v-model="item.riskFive"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="6"
                  label-for="riskSix"
              >
                <b-form-input
                    id="riskSix"
                    v-model="item.riskSix"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group class="pLabel"
                  label="7"
                  label-for="riskSeven"
              >
                <b-form-input
                    id="riskSeven"
                    v-model="item.riskSeven"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <!--SubTitle-->
          <b-row>
            <b-col>
              <b-form-group
                  label="Presencia de Roedores"
              />
            </b-col>
          </b-row>
          <!--End SubTitle-->
          <b-row>
            <b-col cols="1">
              <b-form-group
                  label="Vivos"
                  label-for="riskOne"
              >
                <b-form-input
                    id="roadentsAlive"
                    v-model="item.roadentsAlive"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group
                  label="Muertos"
                  label-for="roadentsDead"
              >
                <b-form-input
                    id="roadentsDead"
                    v-model="item.roadentsDead"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>
<hr>
          <!--SubTitle-->
          <b-row>
            <b-col>
              <b-form-group
                  label="Tipo de Control"
              />
            </b-col>
          </b-row>
          <!--End SubTitle-->
          <b-row>
            <b-col cols="6">
              <b-form-group
                  label="Rodenticida"
              />
            </b-col>
            <b-col cols="6">
              <b-form-group
                  label="Trampas"
              />
            </b-col>
          </b-row>
          <b-row>
              <b-col cols="1">
                <b-form-group
                    label="F"
                    label-for="rodenticinaF"
                >
                  <b-form-input
                      id="rodenticinaF"
                      v-model="item.rodenticinaF"
                      placeholder="0"
                      type="number"
                  />
                </b-form-group>
            </b-col>
              <b-col cols="1">
                <b-form-group
                    label="P"
                    label-for="rodenticinaP"
                >
                  <b-form-input
                      id="rodenticinaP"
                      v-model="item.rodenticinaP"
                      placeholder="0"
                      type="number"
                  />
                </b-form-group>
            </b-col>
              <b-col cols="1" offset="4">
                <b-form-group
                    label="Nº"
                    label-for="rodenticinaN"
                >
                  <b-form-input
                      id="rodenticinaN"
                      v-model="item.rodenticinaN"
                      placeholder="0"
                      type="number"
                  />
                </b-form-group>
            </b-col>
              <b-col cols="1">
                <b-form-group
                    label="S"
                    label-for="rodenticinaS"
                >
                  <b-form-input
                      id="rodenticinaS"
                      v-model="item.rodenticinaS"
                      placeholder="0"
                      type="number"
                  />
                </b-form-group>
            </b-col>
              <b-col cols="1">
                <b-form-group
                    label="DG"
                    label-for="rodenticinaDG"
                >
                  <b-form-input
                      id="rodenticinaDG"
                      v-model="item.rodenticinaDG"
                      placeholder="0"
                      type="number"
                  />
                </b-form-group>
            </b-col>
              <b-col cols="1">
                <b-form-group
                    label="J"
                    label-for="rodenticinaJ"
                >
                  <b-form-input
                      id="rodenticinaJ"
                      v-model="item.rodenticinaJ"
                      placeholder="0"
                      type="number"
                  />
                </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="2">
              <b-form-group
                  label="Roedores Capturados"
                  label-for="riskFive"
              >
                <b-form-input
                    id="capture"
                    v-model="item.capture"
                    placeholder="0"
                    type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>

            <b-col cols="12" class="mt-2">
              <b-alert
                  variant="warning"
                  v-if="errorMessage"
                  show
              >
                <div class="alert-body font-small-2">
                  <p>
                    <small class="mr-50">
                      <span class="font-weight-bold">{{ errorMessage }}</span>
                    </small>
                  </p>
                </div>
              </b-alert>
            </b-col>

            <b-col class="mt-2 mb-4">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
              >
                <span v-if="!loading">Guardar</span>
                <span v-if="loading">Un momento...</span>
              </b-button>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  to="roadents/list"
              >
                Cancelar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert, BAvatar, BBadge, BPagination, BForm, BFormGroup, BFormInput, BFormSelect, BRow, BCol,
  BButton, BDropdown, BDropdownItem, BFormDatepicker, BToast, BSpinner, BFormFile, BFormSelectOption
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import environment from "@/environment";
import flatPickr from "vue-flatpickr-component";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {format} from "date-fns";

export default {
  name: 'DocumentAdd',
  components: {
    BAlert,
    BAvatar,
    BBadge,
    BCardCode,
    BPagination,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BRow,
    BCol,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    BToast,
    BSpinner,
    BFormFile,
    flatPickr,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      region: null,
      district: null,
      corregimiento: null,
      localidad: null,
      selectedSince: null,
      errorMessage: '',
      loading:false,
      locations: {
        regiones: [],
        corregimientos: [],
        distritos: [], 
        localidades: []
      },
      item: {}
    }
  },
  mounted() {
    this.getRegiones()
  },
  methods: {
    async getRegiones() {
      try {
        this.loading = true
        const resp = await this.$http.get(`${environment.uri}stats/regiones`)
        this.locations.regiones = resp.data.map(r => {
          return {...r, value: r}
        })
      } catch (error) {
        console.error(error)
        this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
      } finally {
        this.loading = false
      }
    },
    async getDistritos() {
      try {
        this.loading = true
        const resp = await this.$http.get(`${environment.uri}stats/distritos?id_region=${this.region.id_region}`)
        this.locations.distritos = resp.data.map(r => {
          return {...r, value: r}
        })
      } catch (error) {
        console.error(error)
        this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
      } finally {
        this.loading = false
      }
    },
    async getCorregimientos() {
      try {
        this.loading = true
        const resp = await this.$http.get(`${environment.uri}stats/corregimientos?id_region=${this.region.id_region}&codigo_distrito=${this.district.codigo_distrito}`)
        this.locations.corregimientos = resp.data.map(r => {
          return {...r, value: r}
        })
      } catch (error) {
        console.error(error)
        this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
      } finally {
        this.loading = false
      }
    },
    async getLocalidades() {
      try {
        this.loading = true        
        const resp = await this.$http.get(`${environment.uri}stats/localidades?id_region=${this.region.id_region}&codigo_distrito=${this.district.codigo_distrito}&codigo_corregimiento=${this.corregimiento.codigo_corregimiento}`)
        this.locations.localidades = resp.data.map(r => {
          return {...r, value: r}
        })
      } catch (error) {
        console.error(error)
        this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
      } finally {
        this.loading = false
      }
    },
    async save() {
      try {
        this.loading = true
        this.errorMessage = ''

        this.item.regionLabel = this.region.region
        this.item.districtLabel = this.district.distrito
        this.item.corregimientoLabel = this.corregimiento.corregimiento
        this.item.localidadLabel = this.localidad.localidad

        this.item.region = this.region.id_region
        this.item.district = this.district.id_distrito
        this.item.corregimiento = this.corregimiento.id_corregimiento
        this.item.localidad = this.localidad.id_localidad

        await this.$http.post(`${environment.uri}stats/roden`, this.item)
        
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Guardado`,
            icon: 'CoffeeIcon',
            variant: 'Info',
            text: `Has ingresado exitosamente`,
          },
        })
        this.item = {}
        await this.$router.push('/stats/roadents/list')
      } catch (error) {
        console.error(error)
        this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
      } finally {
        this.loading = false
      }
    },
    async formatDateSince(a) {
      try {
        this.loading = true
        const date = new Date(a);
        const fdate = format(date, 'yyyy-MM-dd')
        this.item.dateE = fdate
        const resp = await this.$http
        .get(`${environment.uri}weeks/${fdate}`)
        this.item.week = resp.data.week
      } catch(error) {
        console.error(error)
        this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.pLabel label{
  padding-left: 18px;
}
</style>
